import type { ConfigMap } from './custom-app-config-schema';

export const customConstants: ConfigMap = {
  "toefl": {
    "tenant": {
      "id": "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
      "name": "TOEFL"
    },
    "supportEmail": "TOEFL@ets.org",
    "companyName": "ETS",
    "app": {
      "id": "5ac37912-3205-430a-b88c-0660ddb449c8",
      "name": "TOEFL Practice",
      "font": "greetstandard",
      "trademark": "TOEFL iBT",
      "showDiagnostic": false,
      "purchase": {
        "baseSku": "com.toefl.app.prep"
      },
      "masteryLevels": [
        {
          "id": "belowBasic",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "session.masteryLevels.belowBasic"
          },
          "level": "low"
        },
        {
          "id": "basic",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 5,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "session.masteryLevels.basic"
          },
          "level": "low"
        },
        {
          "id": "belowLowIntermediate",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 4,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "session.masteryLevels.belowLowIntermediate"
          },
          "level": "low"
        },
        {
          "id": "lowIntermediate",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "session.masteryLevels.lowIntermediate"
          },
          "level": "low"
        },
        {
          "id": "highIntermediate",
          "darkColor": "#77851C",
          "lightColor": "#6A780E",
          "sortOrder": 2,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              60,
              79
            ],
            "points": [
              13,
              16
            ]
          },
          "alias": {
            "title": "session.masteryLevels.highIntermediate"
          },
          "level": "medium"
        },
        {
          "id": "advanced",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "session.masteryLevels.advanced"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            39
          ],
          "range": "0-59",
          "color": "rgba(212, 84, 84, 1)",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            40,
            59
          ],
          "range": "60-79",
          "color": "rgba(181, 77, 33, 1)",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            60,
            100
          ],
          "range": "80-100",
          "color": "rgba(82, 167, 141, 1)",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 17,
        "answer": 15
      },
      "componentOverrides": {
        "button": {
          "labelStyle": {
            "letterSpacing": 2,
            "textTransform": "uppercase"
          }
        }
      },
      "analytics": {
        "mixpanel": {
          "id": "f2b45ce0886396e02b9daa8aee85b803"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_dark.png?t=2024-12-09T05%3A34%3A02.187Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_dark.png?t=2024-12-09T05%3A34%3A02.187Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.toefl.com",
        "privacy": "https://www.ets.org/legal/privacy.html",
        "tos": "https://www.ets.org/legal/terms.html",
        "ios": "https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
        "android": "https://play.google.com/store/apps/details?id=org.ets.toeflpracticeaicoach",
        "redeemSupportUrl": "https://www.ets.org/legal/terms.html",
        "companyUrl": "https://ets.org"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_hycCrAhlgNukJDRuKuLsljTgeiY",
          "android": "goog_ZcyeWszvzTgMceoTRNwASRlBkfh"
        },
        "oneSignalAppId": "76841974-61ff-4d8c-a190-b95ce7789e0b",
        "clerk": {
          "publishableKeyDev": "pk_test_Zmlyc3QtY29sdC0zNy5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRvZWZsLmNvbSQ"
        }
      },
      "tagType": {
        "en-US": "skill",
        "ja-JP": "スキル",
        "zh-CN": "技能"
      },
      "aiAssistant": {
        "title": "AI Learning Assistant",
        "alias": "TOEFL AI",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/aila.png",
        "showOriginalQuestion": false,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TOEFL practice"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TOEFL team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/toefl-items//login-graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "filters": [
          {
            "label": {
              "en-US": "Not answered",
              "ja-JP": "未回答",
              "zh-CN": "未回答"
            },
            "distKey": "none"
          },
          {
            "label": {
              "en-US": "Basic",
              "ja-JP": "基礎",
              "zh-CN": "基础"
            },
            "distKey": "basic",
            "color": "rgba(191, 0, 0, 1)"
          },
          {
            "label": {
              "en-US": "Intermediate",
              "ja-JP": "中級",
              "zh-CN": "中级"
            },
            "distKey": "intermediate",
            "color": "#6A780E"
          },
          {
            "label": {
              "en-US": "Advanced",
              "ja-JP": "上級",
              "zh-CN": "高级"
            },
            "distKey": "advanced",
            "color": "rgba(0, 129, 89, 1)"
          }
        ]
      },
      "accountSettings": {
        "showFaqs": true,
        "showPurchasedProducts": true,
        "showLanguageSettings": true,
        "showAudioTestDialog": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      },
      "appAvailabilityRegions": [
        "MX",
        "FR",
        "DE",
        "JP",
        "US"
      ]
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": false
      },
      "stats": [
        {
          "type": "answered",
          "title": "Answered",
          "icon": "check-all",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "timeElapsed",
          "title": "Time Elapsed",
          "icon": "timer-sand",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Estimated proficiency",
            "ja-JP": "推定習熟度",
            "zh-CN": "估计掌握度"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Performance",
            "ja-JP": "パフォーマンス",
            "zh-CN": "表现"
          }
        }
      ],
      "formative": {
        "showPointsBasedScore": true,
        "maxScore": 30
      }
    },
    "onboarding": [
      {
        "step": "welcome",
        "enabled": true,
        "title": "onboarding.steps.welcome.title",
        "description": "onboarding.steps.welcome.description",
        "cta": "onboarding.steps.welcome.cta",
        "graphics": {
          "desktop": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/TOEFL%20Practice/onboarding/onboarding-welcome-graphics-desktop.png",
          "tablet": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/TOEFL%20Practice/onboarding/onboarding-welcome-graphics-tablet.png",
          "mobile": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/TOEFL%20Practice/onboarding/onboarding-welcome-graphic-mobile.png"
        }
      },
      {
        "step": "set-goal",
        "enabled": true,
        "title": "onboarding.steps.goal.title",
        "description": "onboarding.steps.goal.description",
        "data": [
          {
            "title": "onboarding.goals.firstTime.label",
            "image": "design-services",
            "type": "first_attempt",
            "id": "firstTime",
            "description": "onboarding.goals.firstTime.description",
            "label": "onboarding.goals.firstTime.label",
            "icon": "draw"
          },
          {
            "title": "onboarding.goals.firstTime.label",
            "image": "design-services",
            "type": "retake",
            "id": "retaking",
            "description": "onboarding.goals.retaking.description",
            "label": "onboarding.goals.retaking.label",
            "icon": "repeat"
          },
          {
            "title": "onboarding.goals.firstTime.label",
            "image": "design-services",
            "type": "exploring",
            "id": "exploring",
            "description": "onboarding.goals.exploring.description",
            "label": "onboarding.goals.exploring.label",
            "icon": "rule"
          }
        ],
        "cta": "onboarding.steps.goal.cta"
      },
      {
        "step": "set-date",
        "enabled": true,
        "title": "onboarding.steps.testDate.title",
        "description": "onboarding.steps.testDate.description",
        "cta": "onboarding.steps.testDate.cta"
      },
      {
        "step": "skills",
        "enabled": true,
        "title": "onboarding.steps.skills.title",
        "description": "onboarding.steps.skills.description",
        "isMobile": false,
        "cta": "onboarding.steps.skills.cta"
      },
      {
        "step": "demo",
        "enabled": true,
        "title": "onboarding.steps.demo.title",
        "description": "onboarding.steps.demo.description",
        "isMobile": false,
        "cta": "onboarding.steps.demo.cta",
        "demo": {
          "desktop": "https://demo.arcade.software/yBMZ3qE1iBjyrZnOp4wZ?embed&embed_mobile=inline&embed_desktop=inline"
        }
      },
      {
        "step": "features",
        "enabled": true,
        "title": "onboarding.steps.features.title",
        "description": "onboarding.steps.features.description",
        "descriptionMobile": "onboarding.steps.features.descriptionMobile",
        "secondaryCta": "onboarding.steps.features.secondaryCta",
        "cta": "onboarding.steps.features.cta"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "podcasts",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": false
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Profile",
            "name": "profile",
            "icon": {
              "default": "account-outline",
              "selected": "account"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Library",
            "name": "articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "progress": {
            "low": "rgba(212, 84, 84, 1)",
            "high": "rgba(82, 167, 141, 1)",
            "medium": "rgba(181, 77, 33, 1)"
          },
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "confidence": {
            "low": "rgba(212, 84, 84, 1)",
            "high": "rgba(82, 167, 141, 1)",
            "medium": "rgba(181, 77, 33, 1)"
          },
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(119, 118, 128)",
          "primary": "rgb(78, 83, 183)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "progress": {
            "low": "rgba(191, 0, 0, 1)",
            "high": "rgba(0, 129, 89, 1)",
            "medium": "rgba(255, 143, 96, 1)"
          },
          "tertiary": "rgb(121, 83, 106)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(246, 243, 251)",
            "level2": "rgb(241, 238, 249)",
            "level3": "rgb(236, 233, 247)",
            "level4": "rgb(234, 231, 246)",
            "level5": "rgb(230, 228, 245)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(28, 27, 31)",
          "secondary": "rgb(84, 85, 169)",
          "background": "rgb(255, 251, 255)",
          "confidence": {
            "low": "rgba(191, 0, 0, 1)",
            "high": "rgba(0, 129, 89, 1)",
            "medium": "rgba(255, 143, 96, 1)"
          },
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(28, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(143, 148, 255)",
          "inverseSurface": "rgb(49, 48, 52)",
          "outlineVariant": "rgb(199, 197, 208)",
          "surfaceVariant": "rgb(228, 225, 236)",
          "surfaceDisabled": "rgba(28, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(243, 239, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(70, 70, 79)",
          "primaryContainer": "rgb(225, 224, 255)",
          "onSurfaceDisabled": "rgba(28, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(255, 216, 237)",
          "onPrimaryContainer": "rgb(4, 0, 109)",
          "secondaryContainer": "rgb(225, 223, 255)",
          "onTertiaryContainer": "rgb(46, 17, 37)",
          "onSecondaryContainer": "rgb(12, 6, 100)"
        }
      },
      "roundness": 0
    }
  },
  "jbjs": {
    "tenant": {
      "id": "31da93b9-653e-44e9-94ff-b67a7ffd7012",
      "name": "JBJS"
    },
    "supportEmail": "support@mail.jbjs.org",
    "companyName": "JBJS",
    "app": {
      "id": "864cbe1b-be3e-43a5-a079-d7220aaf61a0",
      "name": "JBJS Mobility",
      "font": "opensans",
      "showDiagnostic": true,
      "purchase": {
        "isSubscriptionEnabled": true
      },
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "analytics": {
        "mixpanel": {
          "id": "ffff090966b3236a89669efc6f77c88a"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_logo-stacked_light.png?t=2024-10-07T03%3A44%3A11.974Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app-logo-stacked-dark.png?t=2024-11-18T04%3A17%3A36.802Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_logo-stacked_dark.png?t=2024-10-07T03%3A43%3A59.701Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app-logo-stacked-dark.png?t=2024-11-18T04%3A17%3A36.802Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.jbjs.org",
        "privacy": "https://customersupport.jbjs.org/en-US/privacy-policy-136463",
        "tos": "https://customersupport.jbjs.org/en-US/jbjs-terms-of-use-136462",
        "redeemSupportUrl": "https://app.jbjs.org/legal/terms"
      },
      "keys": {
        "revenueCat": {
          "ios": "",
          "android": ""
        },
        "oneSignalAppId": "",
        "clerk": {
          "publishableKeyDev": "pk_test_c2ltcGxlLW1vbmFyY2gtMTIuY2xlcmsuYWNjb3VudHMuZGV2JA",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmpianMub3JnJA"
        }
      },
      "supportUrl": "https://jbjs.org/terms",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "JBJS AI",
        "alias": "JBJS AI",
        "icon": "https://memorang-prod-icon.s3.amazonaws.com/app-resources/jbjs/ios/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your AI Learning Assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for JBJS Mobility"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official JBJS team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/ACME%20Mockup_light.webp"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "study-pack-outline",
              "selected": "study-pack"
            },
            "enabled": true,
            "custom": true
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Library",
            "name": "articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple-outline",
              "selected": "note-multiple"
            },
            "enabled": false
          },
          {
            "title": "CME",
            "name": "cme",
            "icon": {
              "default": "school-outline",
              "selected": "school"
            },
            "enabled": false
          },
          {
            "title": "Videos",
            "name": "videos",
            "icon": {
              "default": "video-outline",
              "selected": "video"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": true
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "lightbulb-on-outline",
              "selected": "lightbulb-on"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "podium-gold",
              "selected": "podium"
            },
            "enabled": true
          },
          {
            "title": "Profile",
            "name": "profile",
            "icon": {
              "default": "account-outline",
              "selected": "account"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "showFlightCalculator": false,
      "postAnswerStats": {
        "showXpEarned": true,
        "showNumAttempts": true
      },
      "showCrossOut": false
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(160, 140, 137)",
          "primary": "rgb(255, 180, 167)",
          "surface": "rgb(32, 26, 25)",
          "backdrop": "rgba(59, 45, 43, 0.4)",
          "tertiary": "rgb(221, 196, 140)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(43, 34, 32)",
            "level2": "rgb(50, 38, 36)",
            "level3": "rgb(57, 43, 41)",
            "level4": "rgb(59, 45, 42)",
            "level5": "rgb(63, 48, 45)"
          },
          "onPrimary": "rgb(101, 11, 3)",
          "onSurface": "rgb(237, 224, 221)",
          "secondary": "rgb(174, 198, 255)",
          "background": "rgb(32, 26, 25)",
          "onTertiary": "rgb(61, 46, 4)",
          "onSecondary": "rgb(0, 46, 107)",
          "onBackground": "rgb(237, 224, 221)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(165, 59, 43)",
          "inverseSurface": "rgb(237, 224, 221)",
          "outlineVariant": "rgb(83, 67, 64)",
          "surfaceVariant": "rgb(83, 67, 64)",
          "surfaceDisabled": "rgba(237, 224, 221, 0.12)",
          "inverseOnSurface": "rgb(54, 47, 45)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(216, 194, 190)",
          "primaryContainer": "rgb(133, 35, 22)",
          "onSurfaceDisabled": "rgba(237, 224, 221, 0.38)",
          "tertiaryContainer": "rgb(86, 69, 25)",
          "onPrimaryContainer": "rgb(255, 218, 212)",
          "secondaryContainer": "rgb(19, 68, 143)",
          "onTertiaryContainer": "rgb(251, 224, 166)",
          "onSecondaryContainer": "rgb(216, 226, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 112)",
          "primary": "rgb(165, 59, 43)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(59, 45, 43, 0.4)",
          "tertiary": "rgb(111, 92, 46)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(251, 241, 244)",
            "level2": "rgb(248, 236, 238)",
            "level3": "rgb(245, 230, 232)",
            "level4": "rgb(244, 228, 230)",
            "level5": "rgb(242, 224, 225)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 25)",
          "secondary": "rgb(51, 92, 168)",
          "background": "rgb(255, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 25)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 180, 167)",
          "inverseSurface": "rgb(54, 47, 45)",
          "outlineVariant": "rgb(216, 194, 190)",
          "surfaceVariant": "rgb(245, 221, 217)",
          "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 235)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 64)",
          "primaryContainer": "rgb(255, 218, 212)",
          "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
          "tertiaryContainer": "rgb(251, 224, 166)",
          "onPrimaryContainer": "rgb(64, 2, 0)",
          "secondaryContainer": "rgb(216, 226, 255)",
          "onTertiaryContainer": "rgb(37, 26, 0)",
          "onSecondaryContainer": "rgb(0, 26, 66)"
        }
      }
    }
  },
  "hiset": {
    "tenant": {
      "id": "ab10130c-2a45-4f14-8c14-aae29b744640",
      "name": "HiSet"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "2c183c41-6dc0-4ef4-837c-0eb0f86a61b2",
      "name": "HiSet",
      "font": "opensans",
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "fa9c619bbdd5631c565a957a1bc0b1b5"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/hiset/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/hiset/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/hiset/app_logo_light.png?t=2024-09-16T04%3A56%3A45.812Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/hiset/app_logo_dark.png?t=2024-09-16T04%3A56%3A33.067Z"
          }
        },
        "company": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/psi/company_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/psi/company_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.psiexams.com",
        "privacy": "https://app.psiexams.com/legal/privacy",
        "tos": "https://app.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "",
          "android": ""
        },
        "oneSignalAppId": ""
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AiLA",
        "icon": "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
          "ja-JP": "👋 こんにちは、私は **{{alias}}**、あなたの **{{title}}** です！**{{context}}** の準備をより良くするためにお手伝いします。特に、あなたが回答した **{{topic}}** について深掘りしていきましょう。"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "showCountrySelection": false
    },
    "groupByCategory": true,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": null,
    "showStudyPackAsHome": null,
    "reportView": null,
    "onboarding": [
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(161, 201, 255)",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(255, 178, 191)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(41, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(45, 52, 62)"
          },
          "onPrimary": "rgb(0, 50, 90)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(99, 219, 181)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(102, 0, 40)",
          "onSecondary": "rgb(0, 56, 42)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(16, 96, 164)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 128)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(144, 0, 59)",
          "onPrimaryContainer": "rgb(210, 228, 255)",
          "secondaryContainer": "rgb(0, 81, 62)",
          "onTertiaryContainer": "rgb(255, 217, 222)",
          "onSecondaryContainer": "rgb(129, 248, 208)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(118, 118, 128)",
          "primary": "rgb(62, 85, 191)",
          "surface": "#fff",
          "backdrop": "rgba(47, 48, 56, 0.4)",
          "tertiary": "rgb(0, 108, 81)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(255, 255, 255)",
            "level2": "rgb(255, 255, 255)",
            "level3": "rgb(255, 255, 255)",
            "level4": "rgb(255, 255, 255)",
            "level5": "rgb(255, 255, 255)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(0, 102, 137)",
          "background": "#fafafa",
          "onTertiary": "rgb(255, 255, 255)",
          "quartenary": "rgb(177, 38, 77)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "onQuartenary": "rgb(255, 255, 255)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(185, 195, 255)",
          "inverseSurface": "rgb(48, 48, 52)",
          "outlineVariant": "rgb(198, 197, 208)",
          "surfaceVariant": "rgb(227, 225, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(243, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(70, 70, 79)",
          "primaryContainer": "rgb(222, 225, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "#39A583",
          "onPrimaryContainer": "rgb(0, 18, 88)",
          "secondaryContainer": "rgb(195, 232, 255)",
          "onTertiaryContainer": "#fff",
          "quartenaryContainer": "rgb(255, 217, 221)",
          "onSecondaryContainer": "rgb(0, 30, 44)",
          "onQuartenaryContainer": "rgb(64, 0, 19)"
        }
      }
    }
  },
  "cambridge": {
    "tenant": {
      "id": "ac5beb53-5cfb-4686-8937-c5aa247c26b2",
      "name": "Cambridge"
    },
    "supportEmail": "info@cambridge.com",
    "companyName": "Cambridge",
    "app": {
      "id": "d0675f88-2425-413d-8010-88ade0acfbe3",
      "name": "English Language Assessment (ELA)",
      "font": "opensans",
      "trademark": "Cambridge",
      "showDiagnostic": false,
      "showPracticeTests": false,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "#d66565",
          "lightColor": "#d66565",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "#dda53a",
          "lightColor": "#dda53a",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "medium"
        },
        {
          "id": "high",
          "darkColor": "#66bb68",
          "lightColor": "#66bb68",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            59
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            60,
            79
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            80,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "5ca6baabd67e8dd5f0d5a1c40efe4e9e"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo_stacked_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/logo.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.english.cambridge.memorang.app",
        "privacy": "https://app.english.cambridge.memorang.app/legal/privacy",
        "tos": "https://app.english.cambridge.memorang.app/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://https://app.english.cambridge.memorang.app/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_hxJpHOCyENvIIsfcDNkqIaqoOOr",
          "android": "goog_MzCEOJOlDimhsBBETHElyQDOZPV"
        },
        "oneSignalAppId": "236a14f3-9b96-4664-957c-a44b24fcd7f0",
        "clerk": {
          "publishableKeyDev": "pk_test_YXJyaXZpbmctY3Jhd2RhZC0yNi5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmVuZ2xpc2guY2FtYnJpZGdlLm1lbW9yYW5nLmFwcCQ"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "skill"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "CUPA AI",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/aila.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for English Language Assessment (ELA)"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official Cambridge team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/cambridge/cambridge-test-prep/apps/Graphic.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Skills"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Skills"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": false
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(160, 140, 138)",
          "primary": "rgb(255, 179, 174)",
          "surface": "rgb(32, 26, 26)",
          "backdrop": "rgba(59, 45, 44, 0.4)",
          "tertiary": "rgb(226, 194, 140)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(43, 34, 33)",
            "level2": "rgb(50, 38, 38)",
            "level3": "rgb(57, 43, 42)",
            "level4": "rgb(59, 44, 44)",
            "level5": "rgb(63, 47, 47)"
          },
          "onPrimary": "rgb(104, 0, 11)",
          "onSurface": "rgb(237, 224, 222)",
          "secondary": "rgb(183, 196, 255)",
          "background": "rgb(32, 26, 26)",
          "onTertiary": "rgb(64, 45, 4)",
          "onSecondary": "rgb(13, 40, 120)",
          "onBackground": "rgb(237, 224, 222)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(189, 13, 32)",
          "inverseSurface": "rgb(237, 224, 222)",
          "outlineVariant": "rgb(83, 67, 66)",
          "surfaceVariant": "rgb(83, 67, 66)",
          "surfaceDisabled": "rgba(237, 224, 222, 0.12)",
          "inverseOnSurface": "rgb(54, 47, 46)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(216, 194, 191)",
          "primaryContainer": "rgb(147, 0, 20)",
          "onSurfaceDisabled": "rgba(237, 224, 222, 0.38)",
          "tertiaryContainer": "rgb(89, 67, 25)",
          "onPrimaryContainer": "rgb(255, 218, 215)",
          "secondaryContainer": "rgb(42, 65, 144)",
          "onTertiaryContainer": "rgb(255, 222, 166)",
          "onSecondaryContainer": "rgb(221, 225, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 113)",
          "primary": "rgb(189, 13, 32)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(59, 45, 44, 0.4)",
          "tertiary": "rgb(114, 91, 46)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(252, 239, 244)",
            "level2": "rgb(250, 232, 237)",
            "level3": "rgb(248, 225, 231)",
            "level4": "rgb(247, 222, 228)",
            "level5": "rgb(246, 218, 224)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 26)",
          "secondary": "rgb(68, 89, 169)",
          "background": "rgb(255, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 26)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 179, 174)",
          "inverseSurface": "rgb(54, 47, 46)",
          "outlineVariant": "rgb(216, 194, 191)",
          "surfaceVariant": "rgb(245, 221, 219)",
          "surfaceDisabled": "rgba(32, 26, 26, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 236)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 66)",
          "primaryContainer": "rgb(255, 218, 215)",
          "onSurfaceDisabled": "rgba(32, 26, 26, 0.38)",
          "tertiaryContainer": "rgb(255, 222, 166)",
          "onPrimaryContainer": "rgb(65, 0, 4)",
          "secondaryContainer": "rgb(221, 225, 255)",
          "onTertiaryContainer": "rgb(39, 25, 0)",
          "onSecondaryContainer": "rgb(0, 20, 82)"
        }
      }
    }
  },
  "wocncb": {
    "tenant": {
      "id": "4c80ce98-ef6c-41c8-ab54-f4db19c75136",
      "name": "WOCNCB"
    },
    "supportEmail": "info@wocncb.org ",
    "companyName": "PSI",
    "app": {
      "id": "3dc9d834-de55-4863-b55b-dc155b1772f1",
      "name": "WOCNCB",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "231157f1f863de509dee703a59a7eae2"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_dark_new.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark_new.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.wocncb.org",
        "privacy": "https://app.wocncb.org/legal/privacy",
        "tos": "https://app.wocncb.org/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.wocncb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_AjPruGvspvUXzefpAWxOIHvjvPD",
          "android": "goog_HAXzINaGLxSfBduzHQAFiJHysEZ"
        },
        "oneSignalAppId": "92935195-1416-45d0-8318-57659142569b",
        "clerk": {
          "publishableKeyDev": "pk_test_Y29tcGxldGUtbWVlcmthdC02NS5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLndvY25jYi5vcmck"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "WOCNCB AI",
        "alias": "WOCNCB AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your AI Learning Assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": false,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for WOCNCB"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/landing.webp"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(148, 143, 153)",
          "primary": "rgb(211, 187, 255)",
          "surface": "rgb(29, 27, 30)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(240, 183, 197)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(38, 35, 41)",
            "level2": "rgb(44, 40, 48)",
            "level3": "rgb(49, 45, 55)",
            "level4": "rgb(51, 46, 57)",
            "level5": "rgb(55, 49, 62)"
          },
          "onPrimary": "rgb(59, 29, 112)",
          "onSurface": "rgb(230, 225, 230)",
          "secondary": "rgb(255, 184, 107)",
          "background": "rgb(29, 27, 30)",
          "onTertiary": "rgb(74, 37, 48)",
          "onSecondary": "rgb(73, 41, 0)",
          "onBackground": "rgb(230, 225, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(107, 78, 162)",
          "inverseSurface": "rgb(230, 225, 230)",
          "outlineVariant": "rgb(73, 69, 78)",
          "surfaceVariant": "rgb(73, 69, 78)",
          "surfaceDisabled": "rgba(230, 225, 230, 0.12)",
          "inverseOnSurface": "rgb(50, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(203, 196, 207)",
          "primaryContainer": "rgb(83, 54, 136)",
          "onSurfaceDisabled": "rgba(230, 225, 230, 0.38)",
          "tertiaryContainer": "rgb(100, 59, 70)",
          "onPrimaryContainer": "rgb(235, 221, 255)",
          "secondaryContainer": "rgb(104, 61, 0)",
          "onTertiaryContainer": "rgb(255, 217, 225)",
          "onSecondaryContainer": "rgb(255, 220, 188)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(122, 117, 127)",
          "primary": "rgb(107, 78, 162)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(126, 82, 93)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(248, 242, 250)",
            "level2": "rgb(243, 237, 248)",
            "level3": "rgb(239, 232, 245)",
            "level4": "rgb(237, 230, 244)",
            "level5": "rgb(234, 227, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(29, 27, 30)",
          "secondary": "rgb(137, 81, 0)",
          "background": "rgb(255, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(29, 27, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(211, 187, 255)",
          "inverseSurface": "rgb(50, 48, 51)",
          "outlineVariant": "rgb(203, 196, 207)",
          "surfaceVariant": "rgb(231, 224, 235)",
          "surfaceDisabled": "rgba(29, 27, 30, 0.12)",
          "inverseOnSurface": "rgb(245, 239, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(73, 69, 78)",
          "primaryContainer": "rgb(235, 221, 255)",
          "onSurfaceDisabled": "rgba(29, 27, 30, 0.38)",
          "tertiaryContainer": "rgb(255, 217, 225)",
          "onPrimaryContainer": "rgb(38, 0, 89)",
          "secondaryContainer": "rgb(255, 220, 188)",
          "onTertiaryContainer": "rgb(49, 16, 27)",
          "onSecondaryContainer": "rgb(44, 23, 0)"
        }
      }
    }
  },
  "cmaa": {
    "tenant": {
      "id": "c74b2bbe-16cb-4f04-ab6d-c6f3df67d797",
      "name": "CMAA"
    },
    "supportEmail": "info@cmbuildup.com",
    "companyName": "PSI",
    "app": {
      "id": "c1a1728e-1670-4023-8d14-ba84d0cd0ffe",
      "name": "CMAA Test Prep",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "calibri",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "46faf54b8bf4d619f235301c46b5c5c2"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/cmaa/icons/app_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.nascla.memorang.app",
        "privacy": "https://app.nascla.memorang.app/legal/privacy",
        "tos": "https://app.nascla.memorang.app/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.cmaanet.org"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_rbAMhyzcSUDnGUZsyAFPBGlNHyZ",
          "android": ""
        },
        "oneSignalAppId": "503cf89c-27ec-4469-9f47-5f2e7089af21",
        "clerk": {
          "publishableKeyDev": "pk_test_bmVhdC1pbXBhbGEtNjUuY2xlcmsuYWNjb3VudHMuZGV2JA",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLm5hc2NsYS5tZW1vcmFuZy5hcHAk"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AiLA",
        "icon": "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
          "ja-JP": "👋 こんにちは、私は **{{alias}}**、あなたの **{{title}}** です！**{{context}}** の準備をより良くするためにお手伝いします。特に、あなたが回答した **{{topic}}** について深掘りしていきましょう。"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for CMAA Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official CMAA team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(165, 200, 255)",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(45, 49, 56, 0.4)",
          "tertiary": "rgb(218, 189, 226)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(41, 47, 55)",
            "level4": "rgb(43, 49, 57)",
            "level5": "rgb(46, 52, 62)"
          },
          "onPrimary": "rgb(0, 49, 94)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(189, 208, 91)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(61, 41, 70)",
          "onSecondary": "rgb(44, 52, 0)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(7, 95, 172)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 71, 133)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(85, 63, 94)",
          "onPrimaryContainer": "rgb(212, 227, 255)",
          "secondaryContainer": "rgb(65, 76, 0)",
          "onTertiaryContainer": "rgb(247, 217, 255)",
          "onSecondaryContainer": "rgb(217, 236, 116)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(116, 119, 127)",
          "primary": "rgb(7, 95, 172)",
          "surface": "rgb(253, 252, 255)",
          "backdrop": "rgba(45, 49, 56, 0.4)",
          "tertiary": "rgb(109, 86, 118)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(241, 244, 251)",
            "level2": "rgb(233, 239, 248)",
            "level3": "rgb(226, 235, 246)",
            "level4": "rgb(224, 233, 245)",
            "level5": "rgb(219, 230, 243)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(26, 28, 30)",
          "secondary": "rgb(87, 101, 0)",
          "background": "rgb(253, 252, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(26, 28, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(165, 200, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(195, 198, 207)",
          "surfaceVariant": "rgb(224, 226, 236)",
          "surfaceDisabled": "rgba(26, 28, 30, 0.12)",
          "inverseOnSurface": "rgb(241, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(67, 71, 78)",
          "primaryContainer": "rgb(212, 227, 255)",
          "onSurfaceDisabled": "rgba(26, 28, 30, 0.38)",
          "tertiaryContainer": "rgb(247, 217, 255)",
          "onPrimaryContainer": "rgb(0, 28, 58)",
          "secondaryContainer": "rgb(217, 236, 116)",
          "onTertiaryContainer": "rgb(39, 20, 48)",
          "onSecondaryContainer": "rgb(25, 30, 0)"
        }
      }
    }
  },
  "psi": {
    "tenant": {
      "id": "dcfc373c-0870-4a88-88c3-4a706de51463",
      "name": "PSI"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "2c183c41-6dc0-4ef4-837c-0eb0f86a61b1",
      "name": "PSI Test Prep",
      "maintenance": {
        "enabled": true,
        "title": "We'll be right back",
        "urls": {
          "ios": "https://apps.apple.com/us/app/psi-test-prep/id1565909858",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en_IN"
        },
        "subtitle": "We are currently making improvements to enhance your experience. The PSI app is temporarily unavailable due to maintenance. We apologize for any inconvenience and appreciate your patience. Once maintenance is complete, the current version of the app will no longer be supported. 👉 If you are on mobile, please update to the latest version of the app from the App Store or Google Play Store to continue using it."
      },
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "e2354d451161a9deacf641952f49ab00"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_light.png?t=2024-09-11T02%3A52%3A07.652Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_dark.png?t=2024-09-11T02%3A52%3A21.053Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_light.png?t=2024-09-11T02%3A52%3A32.632Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_dark.png?t=2024-09-11T02%3A52%3A42.516Z"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.psiexams.com",
        "privacy": "https://app.psiexams.com/legal/privacy",
        "tos": "https://app.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_tfbBxQbsoZLVyISjLSZWoccqCzi",
          "android": "goog_xnLVKZpZmlknMbzVJXNOLTdigye"
        },
        "oneSignalAppId": "67d6088f-0bcd-4d04-9984-b5f8efa0dcfc",
        "clerk": {
          "publishableKeyDev": "pk_test_Z2FtZS1saW9uZXNzLTgyLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/assistant/assistant_dark.png?t=2024-09-20T04%3A10%3A34.686Z",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "chooseCategory",
        "enabled": true,
        "title": "Choose Category",
        "description": "onboarding.steps.chooseCategory.description"
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": false,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(251, 252, 254)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      }
    }
  },
  "therapyed": {
    "tenant": {
      "id": "53d94851-4af6-4dfc-943d-92929b3e9dcc",
      "name": "TherapyEd"
    },
    "supportEmail": "info@therapyed.com",
    "companyName": "TherapyEd",
    "app": {
      "id": "db878dfd-9617-456b-b458-14902e06462f",
      "name": "TherapyEd",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "https://apps.apple.com/us/app/therapyed/id1590041414",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.therapyed"
        },
        "subtitle": "We are currently making improvements to enhance your experience. TherapyEd app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "opensans",
      "trademark": "TherapyEd",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "5b3fe7e0378f1a1bd87bc085ddc9b66e"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.therapyed.com",
        "privacy": "https://app.therapyed.com/legal/privacy",
        "tos": "https://app.therapyed.com/legal/terms",
        "redeemSupportUrl": "https://therapyed.zendesk.com/hc/en-us/articles/6864418376468-How-can-I-redeem-access-to-my-purchased-content-",
        "companyUrl": "https://www.therapyed.com/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_LCnNlSXwMCLCGLQsftcakAoejTs",
          "android": "goog_cFBRaPbCakxtxjBbmsUDprlTzfN"
        },
        "oneSignalAppId": "ac799c9b-47da-4692-b722-ce25feffc4ca",
        "clerk": {
          "publishableKeyDev": "pk_test_ZnJlZS1sZW9wYXJkLTExLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRoZXJhcHllZC5jb20k"
        }
      },
      "supportUrl": "https://therapyed.zendesk.com/hc/en-us",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AiLA",
        "icon": "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
          "ja-JP": "👋 こんにちは、私は **{{alias}}**、あなたの **{{title}}** です！**{{context}}** の準備をより良くするためにお手伝いします。特に、あなたが回答した **{{topic}}** について深掘りしていきましょう。"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TherapyEd Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TherapyEd team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/therapyed/therapyed/aibl/landing_graphic.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": false,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(140, 145, 153)",
          "primary": "#F78F1E",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(196, 203, 151)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(40, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(44, 52, 62)"
          },
          "onPrimary": "rgb(76, 39, 0)",
          "onSurface": "rgb(226, 226, 230)",
          "secondary": "rgb(157, 202, 255)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(45, 51, 13)",
          "onSecondary": "rgb(0, 50, 87)",
          "onBackground": "rgb(226, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(0, 98, 161)",
          "inverseSurface": "rgb(226, 226, 230)",
          "outlineVariant": "rgb(66, 71, 78)",
          "surfaceVariant": "rgb(66, 71, 78)",
          "surfaceDisabled": "rgba(226, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(194, 199, 207)",
          "primaryContainer": "rgb(109, 58, 0)",
          "onSurfaceDisabled": "rgba(226, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(68, 74, 34)",
          "onPrimaryContainer": "rgb(255, 220, 194)",
          "secondaryContainer": "rgb(0, 73, 123)",
          "onTertiaryContainer": "rgb(224, 231, 177)",
          "onSecondaryContainer": "rgb(208, 228, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 111)",
          "primary": "#ab351a",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(59, 45, 42, 0.4)",
          "tertiary": "rgb(106, 87, 120)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(255, 255, 255)",
            "level2": "rgb(255, 255, 255)",
            "level3": "rgb(255, 255, 255)",
            "level4": "rgb(255, 255, 255)",
            "level5": "rgb(255, 255, 255)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 25)",
          "secondary": "rgb(0, 98, 162)",
          "background": "#f2f2f2",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 25)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 180, 163)",
          "inverseSurface": "rgb(54, 47, 45)",
          "outlineVariant": "rgb(216, 194, 189)",
          "surfaceVariant": "rgb(245, 221, 216)",
          "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 235)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 64)",
          "primaryContainer": "rgb(255, 218, 210)",
          "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
          "tertiaryContainer": "rgb(242, 218, 255)",
          "onPrimaryContainer": "rgb(61, 6, 0)",
          "secondaryContainer": "rgb(209, 228, 255)",
          "onTertiaryContainer": "rgb(37, 20, 50)",
          "onSecondaryContainer": "rgb(0, 29, 53)"
        }
      }
    }
  },
  "nascla": {
    "tenant": {
      "id": "6635a8d9-38e4-4051-928c-42df9e591995",
      "name": "NASCLA"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "bcba4050-d047-49c7-a863-ad0d3b7b799c",
      "name": "NASCLA Test Prep",
      "maintenance": {
        "enabled": false,
        "title": "We'll be right back",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "NASCLA",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "282437d9532186634a11c1766aaa9d79"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.nascla.psiexams.com",
        "privacy": "https://app.nascla.psiexams.com/legal/privacy",
        "tos": "https://app.nascla.psiexams.com/legal/terms",
        "ios": "",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.nascla.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_ccxywHbvHLWINlyzqbXuejIwZFj",
          "android": "goog_MwTFBdxrtZcnfnbKAnxdFEfhmAO"
        },
        "oneSignalAppId": "72f30699-4b1c-4ec7-9795-747a60cd5045",
        "clerk": {
          "publishableKeyDev": "pk_test_c3dlZXBpbmctZW11LTY3LmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLm5hc2NsYS5wc2lleGFtcy5jb20k"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/assistant/assistant_dark.png?t=2024-09-20T04%3A10%3A34.686Z",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for NASCLA Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official NASCLA team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(163, 201, 255)",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(217, 189, 227)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(41, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(45, 52, 62)"
          },
          "onPrimary": "rgb(0, 49, 92)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 182, 136)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(60, 41, 71)",
          "onSecondary": "rgb(81, 36, 0)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(22, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 130)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(84, 63, 94)",
          "onPrimaryContainer": "rgb(211, 227, 255)",
          "secondaryContainer": "rgb(115, 54, 0)",
          "onTertiaryContainer": "rgb(245, 217, 255)",
          "onSecondaryContainer": "rgb(255, 219, 199)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(115, 119, 127)",
          "primary": "rgb(22, 96, 165)",
          "surface": "rgb(253, 252, 255)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(109, 86, 119)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(241, 244, 251)",
            "level2": "rgb(235, 240, 248)",
            "level3": "rgb(228, 235, 245)",
            "level4": "rgb(225, 233, 244)",
            "level5": "rgb(221, 230, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(26, 28, 30)",
          "secondary": "rgb(149, 73, 7)",
          "background": "rgb(253, 252, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(26, 28, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(163, 201, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(195, 198, 207)",
          "surfaceVariant": "rgb(223, 226, 235)",
          "surfaceDisabled": "rgba(26, 28, 30, 0.12)",
          "inverseOnSurface": "rgb(241, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(67, 71, 78)",
          "primaryContainer": "rgb(211, 227, 255)",
          "onSurfaceDisabled": "rgba(26, 28, 30, 0.38)",
          "tertiaryContainer": "rgb(245, 217, 255)",
          "onPrimaryContainer": "rgb(0, 28, 56)",
          "secondaryContainer": "rgb(255, 219, 199)",
          "onTertiaryContainer": "rgb(38, 20, 48)",
          "onSecondaryContainer": "rgb(49, 19, 0)"
        }
      }
    }
  },
  "aavsb": {
    "tenant": {
      "id": "36b05d62-872c-404b-9c62-c42a9c5434b8",
      "name": "AAVSB"
    },
    "supportEmail": "info@aavsb.com",
    "companyName": "PSI",
    "app": {
      "id": "86cc8809-4824-4c22-a0f7-88246b597afb",
      "name": "AAVSB",
      "font": "sourcesanspro",
      "trademark": "AAVSB",
      "showDiagnostic": false,
      "showPracticeTests": false,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "c8f990c7eda09ea22a741fd54ff3fde8"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aavsb.org",
        "privacy": "https://app.aavsb.org/legal/privacy",
        "tos": "https://app.aavsb.org/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.aavsb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_RiYIviJZZyKVQNLjkzWJQpitxYU",
          "android": "goog_ukzQuWRLGPOokJXXVWhTwETvDRz"
        },
        "oneSignalAppId": "236a14f3-9b96-4664-957c-a44b24fcd7f0",
        "clerk": {
          "publishableKeyDev": "pk_test_c2luY2VyZS1maWxseS0yMy5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmFhdnNiLm9yZyQ"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Study Pawtner",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/assistant_icon_light.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": false,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for AAVSB Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official AAVSB team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/landing_graphic.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "label": "Assessments",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": false
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration. Looking to schedule/reschedule your official exam? [**Click here**](https://www.aavsb.org/students-exams/veterinary-technician-national-exam/applying-to-take-the-vtne/)"
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Home",
            "name": "study-pack",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(142, 144, 153)",
          "primary": "rgb(172, 199, 255)",
          "surface": "rgb(27, 27, 31)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(221, 188, 223)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(34, 36, 42)",
            "level2": "rgb(39, 41, 49)",
            "level3": "rgb(43, 46, 56)",
            "level4": "rgb(44, 48, 58)",
            "level5": "rgb(47, 51, 62)"
          },
          "onPrimary": "rgb(0, 47, 103)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 176, 206)",
          "background": "rgb(27, 27, 31)",
          "onTertiary": "rgb(63, 40, 68)",
          "onSecondary": "rgb(100, 0, 58)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(46, 93, 168)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(68, 71, 78)",
          "surfaceVariant": "rgb(68, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(196, 198, 208)",
          "primaryContainer": "rgb(9, 69, 142)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(87, 62, 91)",
          "onPrimaryContainer": "rgb(215, 226, 255)",
          "secondaryContainer": "rgb(140, 0, 84)",
          "onTertiaryContainer": "rgb(251, 215, 252)",
          "onSecondaryContainer": "rgb(255, 217, 229)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(116, 119, 127)",
          "primary": "rgb(46, 93, 168)",
          "surface": "rgb(254, 251, 255)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(112, 85, 116)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(244, 243, 251)",
            "level2": "rgb(237, 238, 248)",
            "level3": "rgb(231, 234, 245)",
            "level4": "rgb(229, 232, 245)",
            "level5": "rgb(225, 229, 243)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(173, 35, 109)",
          "background": "rgb(254, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(172, 199, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(196, 198, 208)",
          "surfaceVariant": "rgb(224, 226, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(242, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(68, 71, 78)",
          "primaryContainer": "rgb(215, 226, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(251, 215, 252)",
          "onPrimaryContainer": "rgb(0, 26, 64)",
          "secondaryContainer": "rgb(255, 217, 229)",
          "onTertiaryContainer": "rgb(41, 19, 46)",
          "onSecondaryContainer": "rgb(62, 0, 34)"
        }
      }
    }
  },
  "faa": {
    "tenant": {
      "id": "17b4c5fe-6373-4ae0-989a-8ee2b79c417c",
      "name": "PSI"
    },
    "supportEmail": "support@app.aviation.psiexams.com",
    "companyName": "PSI",
    "app": {
      "id": "16cf7bb8-047a-418d-bfe8-e6b22e46d7b1",
      "name": "PSI Aviation Test Prep",
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "fb3c79e43fdfa23b40bc23fc4e365226"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aviation.psiexams.com",
        "privacy": "https://app.aviation.psiexams.com/legal/privacy",
        "tos": "https://app.aviation.psiexams.com/legal/terms",
        "ios": "",
        "android": "",
        "redeemSupportUrl": "https://app.aviation.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_DiGjBeJxHsEifBsXveNNGQfVkQq",
          "android": "goog_EJYJzpGCMSnBdgwrrNCQcNwDvzv"
        },
        "oneSignalAppId": "26dc479c-21a6-48e4-9c6f-a51bf569d19c",
        "clerk": {
          "publishableKeyDev": "pk_test_bm92ZWwtc3R1ZC05MC5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmF2aWF0aW9uLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Wingman",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/aila.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Aviation Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a Sample test"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/landing.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "elevenLabs": {
        "modelId": "eleven_flash_v2_5",
        "voiceId": "nova"
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "diagnosticLabel": {
        "en-US": "free sample test"
      },
      "practiceTest": {
        "label": "Sample tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject mastery",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "study-pack-outline",
              "selected": "study-pack"
            },
            "enabled": true,
            "custom": true
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "disclaimer": "The FAA testing system includes supplemental publications containing graphics, legends, and maps essential for accurately answering specific exam questions. These resources can be accessed here: [https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf](https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf).\n\\\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam.",
      "welcomeDialog": {
        "diagnostic": {
          "title": "Welcome to your {{examName}}.",
          "body": "The sample test questions are not intended to be used as a study guide; they are a representation of the material that will be found on your actual knowledge test. When you take the real test, you’ll see a tutorial walking you through its navigation and functionality. Although you can access and review the questions as much as you desire, it is recommended you allow enough time to complete the sample test in one sitting and free from distractions.\n\\\nThe total time allotted to complete the exam is **{{hr}} hours or {{min}} minutes**, which is an average of **{{sec}} seconds** per question.\n\\\nFeel free to navigate between questions as you work through them. Once you have finished the test, you will receive a score report with an analysis of your results. Be sure to click on “Review Answers” where you can go question-by-question with additional explanations and help. Good luck!\n\\\n**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
        },
        "disclaimer": "**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
      },
      "showFlightCalculator": true,
      "showCrossOut": true
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(251, 252, 254)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      }
    }
  }
}